import React from "react";

function HomeHeroDescription({ className = "" }) {
  return (
    <section
      className={`w-full flex justify-center px-6 bg-white py-10 md:py-14 ${className}`}
    >
      <p className="max-w-3xl text-center text-gray-600 text-[15px] md:text-[20px] leading-[1.9]">
        Intraverse is built to make travel sales simple and scalable. We give
        you a dashboard, ready-made website or API, backed by the largest
        content inventory, automation that takes care of operations, and
        dedicated support so you can focus on growing your business.
      </p>
    </section>
  );
}

export default HomeHeroDescription;
